export const SET_USER = "SET_USER";
export const SET_ALERT_MESSAGE = "SET_ALERT_MESSAGE";
export const SET_MSG_TYPE = "SET_MSG_TYPE";
